import React from 'react';
import PropTypes from 'prop-types';
import { View, Text, TouchableWithoutFeedback, Animated, Easing } from 'react-native';
import Icon from '../Icon';
import { defaultStyles, DEFAULT_BOTTOM } from './Alert.jss';

const POP_IN_DURATION = 500;
export const POP_OUT_DURATION = 1000;
class Alert extends React.PureComponent {
    static propTypes = {
        onPress: PropTypes.func,
        style: PropTypes.shape({}),
        innerContainerStyle: PropTypes.shape({}),
        message: PropTypes.string,
        icon: PropTypes.string,
        pop: PropTypes.bool,
        disableClicksOnContainer: PropTypes.bool,
    };

    static defaultProps = {
        onPress: () => {},
        style: {},
        innerContainerStyle: {},
        message: '',
        icon: 'warning_yellow_black',
        pop: true,
        disableClicksOnContainer: false,
    };

    constructor(props) {
        super(props);
        this.bottomPosition = new Animated.Value(DEFAULT_BOTTOM);
    }

    componentDidMount() {
        const { pop } = this.props;
        if (pop) this.pop();
    }

    pop(popIn = true) {
        Animated.timing(this.bottomPosition, {
            toValue: popIn ? 0 : DEFAULT_BOTTOM,
            duration: popIn ? POP_IN_DURATION : POP_OUT_DURATION,
            easing: popIn ? Easing.linear : Easing.cubic,
            useNativeDriver: false
        }).start();
    }

    render() {
        const {
            style,
            message,
            onPress,
            icon,
            pop,
            innerContainerStyle,
            disableClicksOnContainer
        } = this.props;

        return (
            <Animated.View
                style={[
                    defaultStyles.outerContainer,
                    pop ? { bottom: this.bottomPosition } : {},
                    style
                ]}
                pointerEvents={disableClicksOnContainer ? 'none' : 'auto'}
            >
                <TouchableWithoutFeedback
                    onPress={() => {
                        if (typeof onPress === 'function') {
                            onPress();
                        }
                        this.pop(false);
                    }}
                >
                    <View style={[defaultStyles.innerContainer, innerContainerStyle]}>
                        <Icon style={defaultStyles.icon} name={icon} />
                        <Text style={defaultStyles.message}>{message}</Text>
                    </View>
                </TouchableWithoutFeedback>
            </Animated.View>
        );
    }
}

export default Alert;
